import { Work } from "./types/Work";

export default function createWorkDraftData({ name, serie, serieNumber, publisher }) {
	return Work.partial().parse({
		name,
		serie,
		serieNumber,
		publisher,
	});
}
